const Chart = require("../../Dashboard/Chart/chart");

const ChartDataLabels = require("chartjs-plugin-datalabels");

const QuantityChart = React.createClass({
  render: function () {
    return <div>
      <div className="h-280 ovy-auto thinScrollbar">
        <Chart
          type="horizontalBar"
          plugins={[ChartDataLabels]}
          datasets={[
            {
              data: this.props.data.map(item => item.value),
              backgroundColor: "#06D051"
            }
          ]}
          labels={this.props.data.map(item => (
            item.name || "Indefinido"
          ))}
          options={{
            legend: false,
            scales: {
              xAxes: [{
                position: 'top',
              }],
            },
            tooltips: {
              callbacks: {
                title: ([tooltipItem]) => {
                  return this.props.data[tooltipItem.index].name || "Indefinido"
                },
                label: (tooltipItem) => {
                  return `Quantidade: ${
                    this.props.data[tooltipItem.index].value} (${this.props.getPercentageValue(
                    tooltipItem,
                    this.props.data,
                    this.props.total
                  )}%)`;
                },
                afterLabel: (tooltipItem) => {
                  return this.props.data[tooltipItem.index].count + " negócios";
                },
              }
            },
            plugins: {
              datalabels: {
                formatter: value => value,
                anchor: "end",
                align: "end"
              }
            },
            onHover: this.props.onHover,
            onClick: this.props.onClick,
          }}
        />
      </div>
      <p className="text-muted fs-14">
        Total de produtos vendidos: {this.props.total}
      </p>
    </div>
  }
})

module.exports = QuantityChart;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/ProductsBestSellers/quantity-chart.jsx